
        var result = require("!!../../../../node_modules/css-loader/index.js!./order-form.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/order-from/order-form.component.css
// module id = 620
// module chunks = 0